import { useState } from 'react';
import { IImageProcessingComments } from '../Types';

type UseImageProcessingCommentsDraftResult = {
    imageProcessingComments: IImageProcessingComments;
    openEditComment: () => void;
    cancelComment: () => void;
    onChangeComment: (event: any) => void;
    applySavedComment: () => void;
};

export function useImageProcessingCommentsDraft(
    imageProcessingCommentsFromStore: any
): UseImageProcessingCommentsDraftResult {
    const [draft, setDraft] = useState<IImageProcessingComments>({
        internalComment: '',
        originalInternalComment: '',
        editInternalComment: false
    });
    const [lastMirroredComments, setLastMirroredComments] = useState<any>(null);

    if (imageProcessingCommentsFromStore && imageProcessingCommentsFromStore !== lastMirroredComments) {
        setLastMirroredComments(imageProcessingCommentsFromStore);
        setDraft({
            ...imageProcessingCommentsFromStore,
            originalInternalComment: imageProcessingCommentsFromStore.internalComment,
            editInternalComment: draft.editInternalComment,
            internalComment: draft.editInternalComment
                ? draft.internalComment
                : imageProcessingCommentsFromStore.internalComment
        });
    }

    const openEditComment = (): void => {
        setDraft({ ...draft, editInternalComment: true });
    };

    const cancelComment = (): void => {
        setDraft({
            ...draft,
            editInternalComment: false,
            internalComment: draft.originalInternalComment
        });
    };

    const onChangeComment = (event: any): void => {
        if (event.target.name.startsWith('imageProcessingComments.')) {
            const field = event.target.name.replace('imageProcessingComments.', '');
            setDraft({ ...draft, [field]: event.target.value });
        }
    };

    const applySavedComment = (): void => {
        setDraft({
            ...draft,
            originalInternalComment: draft.internalComment,
            editInternalComment: false
        });
    };

    return {
        imageProcessingComments: draft,
        openEditComment,
        cancelComment,
        onChangeComment,
        applySavedComment
    };
}
